import { permissionManager } from "../PermissionManager/PermissionManager";
export const FEEDBACK = 'feedback';
export const ESIGN_CN_FEEDBACK = 'e-sign-china-feedback-button';
export const FOXIT_SOFTWARE = 'foxit-software';
export const EDU_EXCLUSIVE = 'edu-exclusive'
export const HELP_CENTER = 'help-center';

export const UPDATE_LOGS = 'update-logs';
export const DOWNLOAD_CLIENT = 'download-client';
export const FOXIT_PLUG_INS = 'foxit-plug-ins'
export const HELP_LIST = [
  FEEDBACK,
  FOXIT_SOFTWARE,
  EDU_EXCLUSIVE,
  HELP_CENTER,
  DOWNLOAD_CLIENT
]

permissionManager.registerNotLoginFeatures([FOXIT_SOFTWARE,
  EDU_EXCLUSIVE,
  HELP_CENTER,
  UPDATE_LOGS,
  DOWNLOAD_CLIENT]);

export const HELP_MAP = {
  feedback: {
    name: FEEDBACK,
    title: 'phantom_online:toolbar.help.feedback.title',
    icon: 'fx-icon-ribbon_help_post_your_idea-32',
    tooltip: 'phantom_online:toolbar.help.feedback.tooltip'
  },
  foxitSoftware: {
    name: FOXIT_SOFTWARE,
    title: 'phantom_online:toolbar.help.foxitSoftware.title',
    icon: 'fx-icon-ribbon_help_about_foxit_phantompdf-32',
    tooltip: 'phantom_online:toolbar.help.foxitSoftware.tooltip'
  },
  eduExclusive: {
    name: EDU_EXCLUSIVE,
    title: 'phantom_online:toolbar.help.eduExclusive.title',
    icon: 'fv__icon-toolbar-edu-exclusive',
    tooltip: 'phantom_online:toolbar.help.eduExclusive.tooltip'
  },
  helpCenter: {
    name: HELP_CENTER,
    title: 'phantom_online:toolbar.help.helpCenter.title',
    icon: 'fx-icon-ribbon_help_help_center-32',
    tooltip: 'phantom_online:toolbar.help.helpCenter.tooltip'
  },
  updateLogs: {
    name: UPDATE_LOGS,
    title: 'phantom_online:toolbar.help.updateLogs.title',
    icon: 'fx-icon-ribbon_help_product_info-32',
    tooltip: 'phantom_online:toolbar.help.updateLogs.tooltip'
  },
  downloadClient: {
    name: DOWNLOAD_CLIENT,
    title: 'phantom_online:toolbar.help.downloadClient.title',
    icon: 'fx-icon-ribbon_help_install_update-32',
    tooltip: 'phantom_online:toolbar.help.downloadClient.tooltip'
  },
  downloadClientCN: {
    name: DOWNLOAD_CLIENT,
    title: 'phantom_online:toolbar.help.downloadClientCN.title',
    icon: 'fx-icon-ribbon_help_install_update-32',
    tooltip: 'phantom_online:toolbar.help.downloadClientCN.tooltip'
  },
  foxitPlugIns: {
    name: FOXIT_PLUG_INS,
    title: 'phantom_online:toolbar.help.foxitPlugIns.title',
    icon: 'fx-icon-ribbon_help_foxit_plug_ins-32',
    tooltip: 'phantom_online:toolbar.help.foxitPlugIns.tooltip'
  }
};
